import { useEffect, useState } from "react";
import { 
  collection, 
  doc, 
  onSnapshot, 
  setDoc, 
  updateDoc, 
  serverTimestamp, 
  getDocs, 
  deleteDoc 
} from "firebase/firestore";
import { db } from "../firebase";
import DiceRoller from "./DiceRoller";
import logo from "../LogoD1.png";

type RoomsProps = {
  roomId: string;
};

export default function Rooms({ roomId }: RoomsProps) {
  const [players, setPlayers] = useState<{ id: string; data: any }[]>([]);
  const [userId] = useState(() => Math.random().toString(36).substring(2, 8));
  const [nicknameEdits, setNicknameEdits] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!roomId) return;

    const playersColRef = collection(db, "rooms", roomId, "players");
    const playerRef = doc(playersColRef, userId);

    const initPlayer = async () => {
      //Controlla se la stanza è inattiva da oltre 1 ora
      const snap = await getDocs(playersColRef);
      const now = Date.now();
      const oneHourAgo = new Date(now - 60 * 60 * 1000);

      let inactive = true;
      snap.forEach((doc) => {
        const lastActive = doc.data().lastActive?.toDate?.();
        if (lastActive && lastActive > oneHourAgo) {
          inactive = false;
        }
      });

      if (inactive && snap.size > 0) {
        // stanza inattiva → elimina tutti i giocatori
        for (const docSnap of snap.docs) {
          await deleteDoc(docSnap.ref);
        }
        console.log(`Stanza ${roomId} resettata per inattività`);
      }

      // 2️⃣ Crea o aggiorna il giocatore corrente DOPO la pulizia
      await setDoc(
        playerRef,
        {
          nickname: "",
          diceResults: Array(6).fill(""),
          lockedDice: Array(6).fill(false),
          removedDice: Array(6).fill(false),
          lastActive: serverTimestamp(),
        },
        { merge: true }
      );

      // 3️⃣ Aggiorna lastActive ogni 5 minuti finché la pagina è aperta
      const interval = setInterval(() => {
        updateDoc(playerRef, { lastActive: serverTimestamp() });
      }, 5 * 60 * 1000);

      // 4️⃣ Ascolta i giocatori della stanza in tempo reale
      const unsub = onSnapshot(playersColRef, (snap) => {
        setPlayers(snap.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
      });

      // Cleanup quando il componente si smonta
      return () => {
        clearInterval(interval);
        unsub();
      };
    };

    initPlayer();

  }, [roomId, userId]);

  // Salva nickname del giocatore
  const saveNickname = async (playerId: string) => {
    const newNickname = nicknameEdits[playerId];
    if (!newNickname) return;
    const playerRef = doc(db, "rooms", roomId, "players", playerId);
    await updateDoc(playerRef, { nickname: newNickname });
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <img
        src={logo}
        alt="Logo"
        style={{ width: "15%", marginBottom: "30px" }}
      />
      <h1>Stanza: {roomId}</h1>
      
    <section className="rules" style={{textAlign: "left"}}>
      <p><strong>NUOVO LANCIO:</strong> Lancia i dadi. Puoi cliccare sul simbolo di un dado per escluderlo dal risultato finale, così
da facilitare il conteggio dei Successi.</p>
      <p><strong>USA L’ABILITÀ:</strong> Consente di rilanciare i dadi. Devi bloccare manualmente quelli che non vuoi - o non
puoi - rilanciare.</p>
      <p><strong>USA LA SICUREZZA:</strong> Trasforma un Fallimento in un Successo.</p>
    </section>

      {players.map(({ id, data }) => (
        <div key={id} style={{ marginBottom: "30px" }}>
          {id === userId ? (
            <div>
              <input
                type="text"
                value={nicknameEdits[id] ?? data.nickname ?? ""}
                onChange={(e) =>
                  setNicknameEdits({ ...nicknameEdits, [id]: e.target.value })
                }
                placeholder="Inserisci nickname"
              />
              <button 
                onClick={() => saveNickname(id)} 
                style={{ marginLeft: "10px" }}
              >
                Salva
              </button>
            </div>
          ) : (
            <h4>{data.nickname || `Giocatore ${id}`}</h4>
          )}

          <DiceRoller
            playerId={id}
            roomId={roomId}
            data={data}
            isOwner={id === userId}
          />
        </div>
      ))}
    </div>
  );
}
